export default [
    // LEADS INDEX
    {
        path: '/conveyancing/residential/legal-advice/leads',
        name: 'residential.legal-advice.leads',
        component: () => import('@/views/dashboard/LeadsIndex.vue'),
        meta: {
            service: 'res-legal-advice',
            type: 'lead',
            smallMenu: true,
            active: 'residential'
        },
    },
    // LEADS SINGLE
    {
        path: '/conveyancing/residential/legal-advice/leads/view/:reference?',
        name: 'residential.legal-advice.leads.view',
        component: () => import('@/views/dashboard/LeadSingle.vue'),
        meta: {
            service: 'res-legal-advice',
            type: 'lead',
            smallMenu: true,
            active: 'residential'
        },
    },

    // QUOTES INDEX
    {
        path: '/conveyancing/residential/legal-advice/quotes',
        name: 'residential.legal-advice.quotes',
        component: () => import('@/views/dashboard/residential/legal-advice/ResidentialLegalAdviceQuotesIndex.vue'),
        meta: {
            service: 'res-legal-advice',
            type: 'quote',
            smallMenu: true,
            active: 'residential'
        },
    },

    // QUOTES SINGLE
    {
        path: '/conveyancing/residential/legal-advice/quotes/view/:reference?',
        component: () => import('@/views/layouts/SingleQuoteWrapper.vue'),
        props: true,
        meta: { 
            service: 'res-legal-advice',
            type: 'quote',
            smallMenu: true,
            active: 'residential'
        },
        children: [
            {
                path: '',
                name: 'services.legal-advice.quote.view',
                component: () => import('@/components/services/QuoteDetailsTab.vue'),
                props: true,
            },
            {
                path: 'summary',
                name: 'services.legal-advice.quote.view.summary',
                component: () => import('@/components/dashboard/residential/legal-advice/ResidentialLegalAdviceQuoteSummary.vue'),
                props: true,
            },
            {
                path: 'fees',
                name: 'services.legal-advice.quote.view.fees',
                component: () => import('@/components/dashboard/misc/QuoteMatterFeesTab.vue'),
                props: true,
            },
            {
                path: 'activity',
                name: 'services.legal-advice.quote.view.activity',
                component: () => import('@/components/dashboard/misc/QuoteMatterActivityTab.vue'),
                props: true,
            },
        ],
    },
];